import React from "react";

export const Header = (props) => {
  const openAgentPage = (event) => {
    if (!props.onOpenPage) return;
    event.preventDefault();
    props.onOpenPage("agent-platform");
  };

  return (
    <header id="header">
      <div className="intro">
        <div className="overlay">
          <div className="container">
            <div className="row">
              <div className="col-md-12 intro-text">
                <a
                  href="#/agent-platform"
                  className="btn btn-custom btn-lg page-scroll"
                  onClick={openAgentPage}
                >
                  Explore Agents
                </a>{" "}
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  );
};
